import * as React from 'react';
import { format } from 'date-fns';

export interface Props {
	sunriseStart: Date | null;
	sunriseEnd: Date | null;
	solarNoon: Date | null;
	sunsetStart: Date | null;
	sunsetEnd: Date | null;
	uvbStart: Date | null;
	uvbEnd: Date | null;
}

const FORMAT = 'h:mm aaa';

const Times: React.StatelessComponent<Props> = ({
	sunriseStart,
	solarNoon,
	sunsetEnd,
	uvbStart,
	uvbEnd,
}) => (
	<div className="Times">
		<div className="row">
			<dl className="col-md text-center">
				<dt>Sunrise</dt>
				<dd>{sunriseStart ? format(sunriseStart, FORMAT) : <em>N/A</em>}</dd>
			</dl>
			<dl className="col-md text-center">
				<dt>UVB penetration begins</dt>
				<dd>{uvbStart ? format(uvbStart, FORMAT) : <em>N/A</em>}</dd>
			</dl>
			<dl className="col-md text-center">
				<dt>Solar noon</dt>
				<dd>{solarNoon ? format(solarNoon, FORMAT) : <em>N/A</em>}</dd>
			</dl>
			<dl className="col-md text-center">
				<dt>UVB penetration ends</dt>
				<dd>{uvbEnd ? format(uvbEnd, FORMAT) : <em>N/A</em>}</dd>
			</dl>
			<dl className="col-md text-center">
				<dt>Sunset</dt>
				<dd>{sunsetEnd ? format(sunsetEnd, FORMAT) : <em>N/A</em>}</dd>
			</dl>
		</div>
	</div>
);

export default Times;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Times.tsx